import { render, staticRenderFns } from "./confirm.vue?vue&type=template&id=4d57aacc&scoped=true&lang=pug&"
import script from "./confirm.vue?vue&type=script&lang=js&"
export * from "./confirm.vue?vue&type=script&lang=js&"
import style0 from "./confirm.vue?vue&type=style&index=0&id=4d57aacc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d57aacc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d57aacc')) {
      api.createRecord('4d57aacc', component.options)
    } else {
      api.reload('4d57aacc', component.options)
    }
    module.hot.accept("./confirm.vue?vue&type=template&id=4d57aacc&scoped=true&lang=pug&", function () {
      api.rerender('4d57aacc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/trust/dialog/confirm.vue"
export default component.exports